import { render, staticRenderFns } from "./link-text.vue?vue&type=template&id=54c69daf&scoped=true&"
import script from "./link-text.vue?vue&type=script&lang=js&"
export * from "./link-text.vue?vue&type=script&lang=js&"
import style0 from "./link-text.vue?vue&type=style&index=0&id=54c69daf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c69daf",
  null
  
)

export default component.exports